import { render, staticRenderFns } from "./management.vue?vue&type=template&id=f4b95f88&scoped=true"
import script from "./management.vue?vue&type=script&lang=js"
export * from "./management.vue?vue&type=script&lang=js"
import style0 from "./management.vue?vue&type=style&index=0&id=f4b95f88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4b95f88",
  null
  
)

export default component.exports